import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { TaskList } from './task-list';
import { MediaGrid } from './media-grid';
import { TeamDropdown } from './team-dropdown';

export const TaskMedia: React.FC = () => {
  const [selectedTeam, setSelectedTeam] = React.useState<{
    code: string;
    name: string;
  }>({ code: 'All Teams', name: 'All Teams' });
  const [selectedTask, setSelectedTask] = React.useState<string>('All Tasks');

  return (
    <Row className={'d-flex flex-grow-1 overflow-hidden p-0 m-0'}>
      <Col
        xs={2}
        className={'d-flex flex-column flex-grow-1 overflow-hidden h-100 p-0'}
        style={{ gap: '16px' }}>
        <TeamDropdown
          selectedTeam={selectedTeam}
          onSelectTeam={setSelectedTeam}
        />
        <div className={'d-flex flex-grow-1 p-0 overflow-auto h-100'}>
          <TaskList
            selectedTask={selectedTask}
            onSelectTask={(taskId) => setSelectedTask(taskId)}
          />
        </div>
      </Col>

      <Col
        xs={10}
        className={'d-flex flex-grow-1 h-100 overflow-auto'}
        style={{
          margin: '0',
          padding: '0 0 0 24px'
        }}>
        <MediaGrid
          selectedTeam={selectedTeam.code}
          selectedTask={selectedTask}
        />
      </Col>
    </Row>
  );
};
